import CIMSFormItem from 'components/CIMSFormItem'
import CIMSTextArea from 'components/CIMSTextArea'
import { Issue } from '../../../IssueTrackerContext/types'
import { IssueStatus } from '@cims-online/shared'
import { HelpMessage } from 'utils/constants'

const ClosureNotes: React.VFC<Issue> = ({ statusId }) => {
  if (statusId !== IssueStatus.Closed.id) return null
  return (
    <CIMSFormItem
      help={HelpMessage.Issues.IssueTracker.ClosureNotes}
      name="closureNotes"
      label="Closure Notes"
    >
      <CIMSTextArea maxLength={2000} />
    </CIMSFormItem>
  )
}

export default ClosureNotes
